export default {
  task: {
    introductionActivitiesResources: "v1/introduction-activities-resources",
  },
};
